import { createSlice } from '@reduxjs/toolkit';

type InitialState = {
	isLoginModalOpen: boolean;
	isRegisterModalOpen: boolean;
	isActivationModalOpen: boolean;
	isForgotPasswordModalOpen: boolean;
	isActivationResultModalOpen: boolean;
	isSetForgotPasswordModalOpen: boolean;
};

const initialState: InitialState = {
	isLoginModalOpen: false,
	isRegisterModalOpen: false,
	isActivationModalOpen: false,
	isForgotPasswordModalOpen: false,
	isActivationResultModalOpen: false,
	isSetForgotPasswordModalOpen: false,
};

const modalsReducer = createSlice({
	name: 'modals',
	initialState,
	reducers: {
		setLoginModalOpen: (state, action) => {
			state.isLoginModalOpen = action.payload;
		},
		setRegistrationModalOpen: (state, action) => {
			state.isRegisterModalOpen = action.payload;
		},
		setActivationModalOpen: (state, action) => {
			state.isActivationModalOpen = action.payload;
		},
		setActivationResultModalOpen: (state, action) => {
			state.isActivationResultModalOpen = action.payload;
		},
		setForgotPasswordModalOpen: (state, action) => {
			state.isSetForgotPasswordModalOpen = action.payload;
		},
	},
});

export const {
	setLoginModalOpen,
	setRegistrationModalOpen,
	setActivationModalOpen,
	setActivationResultModalOpen,
	setForgotPasswordModalOpen,
} = modalsReducer.actions;
export default modalsReducer;
